const mileage = document.getElementById('mileage');
const distance = document.getElementById('daily-distance');
const fuelCost = document.getElementById('fuel-cost');
let calculation = document.getElementById('calculation');
let calculatorList = [mileage, distance, fuelCost];

if (calculation !== null) {
  //filter out anything other then number and perform a calculation
  mileage.addEventListener('input', function (event) {
    let key = event.data;
    let regex = /[0-9]|\./;
    if (!regex.test(key) && event.inputType !== 'deleteContentBackward') {
      this.value = this.value.replace(key, '');
      return;
    }
    updateMileageCalculator(this.value, distance.value, fuelCost.value);
  });

  distance.addEventListener('input', function (event) {
    let key = event.data;
    let regex = /[0-9]|\./;
    if (!regex.test(key) && event.inputType !== 'deleteContentBackward') {
      this.value = this.value.replace(key, '');
      return;
    }
    updateMileageCalculator(mileage.value, this.value, fuelCost.value);
  });

  fuelCost.addEventListener('input', function (event) {
    let key = event.data;
    let regex = /[0-9]|\./;
    if (!regex.test(key) && event.inputType !== 'deleteContentBackward' && key !== '.') {
      this.value = this.value.replace(key, '');
      return;
    }
    updateMileageCalculator(mileage.value, distance.value, this.value);
  });

  //prevent pasting
  calculatorList.addEventListener('paste', function (event) {
    event.preventDefault();
  });
}

//remove extra digits and and $
function trailingDigits(num) {
  return '$' + Number.parseFloat(num).toFixed(2).toString();
}

function updateMileageCalculator(mileage, distance, fuelCost) {
  electricCost = parseInt(distance) * 0.025;
  fuelTotal =
    ((parseInt(distance) / (100 / parseInt(mileage))) * parseFloat(fuelCost) - electricCost) * 30;

  fuelTotal = fuelTotal > 0 ? trailingDigits(fuelTotal) : '$0';
  calculation.innerHTML = fuelTotal;
}
